type TitleProps = {
  content: string
}
export const Title = ({ content }: TitleProps) => (
  <h4 className="mb-8 text-4xl font-semibold text-primary-green print:mb-2">{content}</h4>
)
